import type { FC } from 'react';
import ClaimsSettingsScreen from '../../screens/Claims/Settings/ClaimsSettingsScreen';

const ClaimsSettingsPage: FC = () => {
  return <ClaimsSettingsScreen />;
};

export default ClaimsSettingsPage;
